
const getTypesFromSearchPhrase = (typeList, searchPhrase) => {
    var searchSuggestionList = [];

    typeList.categoriesLv1.forEach((item) => {
        if (item.searchLabel.toLowerCase().includes(searchPhrase.toLowerCase())) {
            searchSuggestionList.push(item)
        }
    })
    typeList.categoriesLv1.forEach((item) => {
        if (item.categoryLv2 && item.categoryLv2.length > 0) {
            item.categoryLv2.forEach((item) => {
                if (item.searchLabel.toLowerCase().includes(searchPhrase.toLowerCase())) {
                    searchSuggestionList.push(item)
                }
            })
        }
    })
    typeList.genres.forEach((item) => {
        if (item.searchLabel.toLowerCase().includes(searchPhrase.toLowerCase())) {
            searchSuggestionList.push(item)
        }
    })
    typeList.thematicsLv1.forEach((item) => {
        if (item.searchLabel.toLowerCase().includes(searchPhrase.toLowerCase())) {
            searchSuggestionList.push(item)
        }
    })
    typeList.thematicsLv2.forEach((item) => {
        if (item.searchLabel.toLowerCase().includes(searchPhrase.toLowerCase())) {
            searchSuggestionList.push(item)
        }
    })
    typeList.thematicsLv3.forEach((item) => {
        if (item.searchLabel.toLowerCase().includes(searchPhrase.toLowerCase())) {
            searchSuggestionList.push(item)
        }
    })
    return searchSuggestionList;
}


export {
    getTypesFromSearchPhrase
}